import React from "react";
import { AppShell } from "@/components/AppShell";
import { AttendanceFlow } from "@/pages/pmc/PmcAttendancePage";
import { useAuth } from "@/lib/auth";

export default function ContractorAttendancePage() {
  const { user } = useAuth();
  const role = user?.role === "supervisor_incharge" ? "supervisor_incharge" : "contractor_supervisor";
  return (
    <AppShell title="Attendance" subtitle="Submitted attendance goes to admin for validation">
      <AttendanceFlow role={role} />
    </AppShell>
  );
}

